import {companyService} from '../services/service-factory';

export default {
  data: function() {
    return {
      companyService: undefined
    };
  },
  created: function() {
    this.companyService = companyService;
  }
};